import { css } from '@emotion/react'

export const Overflow = {
	Hidden: css({ overflow: 'hidden' })
}
